import { memo } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import _map from 'lodash/map';
// Local files
import { StyledList, StyledListItem } from './LogsHistory.styled';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import BaseDialog from 'components/Common/Feedback/BaseDialog/BaseDialog';
import useCustomSelector from 'hooks/useCustomSelector';
import { eventsSelectors } from "features/events";

const LogsHistory = ({ open, analysisId, fetchEvents, onClose }) => {
  const { data, pagination } = useCustomSelector(eventsSelectors.getAnalysesEventsData);
  const eventsFetching = useCustomSelector(eventsSelectors.analysesEventsIsFetching);
  
  const handleScroll = ({ target: { scrollTop, scrollHeight, offsetHeight } }) =>
    (scrollTop + 65) >= scrollHeight - offsetHeight && pagination.total_count > pagination.count + pagination.offset && !eventsFetching && fetchEvents(pagination.limit + pagination.offset, analysisId);

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      otherPaperStyle={{ width: '100%', maxWidth: 800 }}
      title='Logs History'
    >
      <Box sx={{ px: 4, pb: 3 }}>
        <StyledList onScroll={handleScroll}>
          {_map(data, (e) => (
            <StyledListItem key={e.id}>
              <Box sx={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
                <Typography variant='body2' color='textSecondary' sx={{ fontWeight: 800 }}>
                  {!!e?.created_at ?
                    `${new Date(e.created_at).toLocaleString('en-US', { year: '2-digit', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true })}`
                    : '-'
                  }
                </Typography>
                <Typography variant='body2' color='textSecondary' sx={{ wordBreak: 'break-word', fontWeight: 400 }}>
                  {e?.text ?? '-'}
                </Typography>
              </Box>
            </StyledListItem>
          ))}
          {eventsFetching && <Skeleton variant="rectangular" width='95%' height={30} />}
          {data.length === 0 && !eventsFetching && <Typography sx={{ textTransform: 'uppercase', textAlign: 'center' }}>No Logs</Typography>}
        </StyledList>
      </Box>
    </BaseDialog>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <LogsHistory {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);